import { cleanObj } from '@/utils'
import { request } from './request'
import { method } from 'lodash'

export interface GetTemplateData {
  keyword?: string
}

export interface GetTemplateElementData {
  id?: number
}
export const getTemplateElement = (data: GetTemplateElementData) =>
  request('/scvapi/webgateway/resource/elements', {
    params: cleanObj(data as any),
  })

export interface AddTemplateData {
  name: string
  ids: number[]
}

export const addTemplate = (data: AddTemplateData) =>
  request('/scvapi/webgateway/resource/template', {
    method: 'post',
    data,
  })

export const getTargets = () => request('/portal/verify/webGateway/targetList')

export interface GetTemplate {
  template_id: string
}
export const getTemplate = (data: GetTemplate) =>
  request('/portal/verify/webGateway/templateDetail', {
    params: {
      ...data,
    },
  })

/**
 * 创建任务
 */
export interface CreateTask {
  /**
   * 认证账号
   */
  account?: string
  agentToTi?: TaskAgentToTi
  cronSchedule?: BaswebGatewayv1TaskCronSchedule
  /**
   * 安全设备ID列表
   */
  deviceIds?: string[]
  /**
   * 任务执行次数限制
   */
  executionTimes?: number
  /**
   * 任务分组ID
   */
  groupId?: string
  /**
   * 是否启用认证
   */
  isAuth?: boolean
  /**
   * 任务名称
   */
  name?: string
  /**
   * 认证密码
   */
  password?: string
  /**
   * 执行优先级
   */
  priority?: number
  /**
   * 代理地址
   */
  proxy?: string
  reportConfig?: BaswebGatewayv1TaskReportConfig
  /**
   * 用例ID列表
   */
  resourceIds?: string[]
  schedulerType?: BaswebGatewayv1TaskSchedulerType
  /**
   * 发送速率 每秒几个
   */
  speed?: number
  /**
   * 模板列表
   */
  templateList?: BaswebGatewayv1CreateTaskRequestTemplate[]
  /**
   * 超时时间 单位秒
   */
  timeout?: number
  /**
   * 用户ID
   */
  userId?: string
  [property: string]: any
}

/**
 * 验证信息
 */
export interface TaskAgentToTi {
  agentId?: string
  dnsSinkhole?: string
  hostId?: string
  [property: string]: any
}

/**
 * basweb_gatewayv1TaskCronSchedule
 */
export interface BaswebGatewayv1TaskCronSchedule {
  /**
   * 每月的哪几天
   */
  dayOfMonth?: number[]
  /**
   * 周期时间，每周的哪几天
   */
  dayOfWeek?: number[]
  /**
   * 间隔N小时
   */
  intervalOfHour?: number
  /**
   * 间隔N分钟
   */
  intervalOfMinute?: number
  /**
   * (每日/每周/每月)当天的时间 hh:ii:ss
   */
  timeOfDay?: string
  [property: string]: any
}

/**
 * basweb_gatewayv1TaskReportConfig
 */
export interface BaswebGatewayv1TaskReportConfig {
  condition?: BaswebGatewayv1TaskReportConfigCondition
  /**
   * 邮箱
   */
  emailList?: BaswebGatewayv1TaskReportConfigEmail[]
  /**
   * 是否过滤
   */
  filter?: boolean
  /**
   * 是否发送
   */
  send?: boolean
  [property: string]: any
}

/**
 * - condition_anyway: 无条件
 * - condition_all_failed: 全部拦截失败
 * - condition_exist_failed: 存在拦截失败
 */
export enum BaswebGatewayv1TaskReportConfigCondition {
  ConditionAllFailed = 'condition_all_failed',
  ConditionAnyway = 'condition_anyway',
  ConditionExistFailed = 'condition_exist_failed',
}

/**
 * basweb_gatewayv1TaskReportConfigEmail
 */
export interface BaswebGatewayv1TaskReportConfigEmail {
  email?: string
  id?: string
  /**
   * 人员名称
   */
  name?: string
  [property: string]: any
}

/**
 * - scheduler_type_immediate: 即时任务
 * - scheduler_type_reserve: 定时任务
 * - scheduler_type_daily: 每日任务
 * - scheduler_type_weekly: 周任务
 * - scheduler_type_monthly: 月任务
 * - scheduler_type_hourly: 每隔N小时任务
 * - scheduler_type_minutely: 每隔N分钟任务
 */
export enum BaswebGatewayv1TaskSchedulerType {
  SchedulerTypeDaily = 'scheduler_type_daily',
  SchedulerTypeHourly = 'scheduler_type_hourly',
  SchedulerTypeImmediate = 'scheduler_type_immediate',
  SchedulerTypeMinutely = 'scheduler_type_minutely',
  SchedulerTypeMonthly = 'scheduler_type_monthly',
  SchedulerTypeReserve = 'scheduler_type_reserve',
  SchedulerTypeUnknown = 'scheduler_type_unknown',
  SchedulerTypeWeekly = 'scheduler_type_weekly',
}

/**
 * basweb_gatewayv1CreateTaskRequestTemplate
 */
export interface BaswebGatewayv1CreateTaskRequestTemplate {
  /**
   * 模板ID
   */
  id?: string
  /**
   * 使用最新的用例
   */
  useLatestResource?: boolean
  [property: string]: any
}

export const createTask = (data: CreateTask) =>
  request('/portal/verify/webGateway/createTask', {
    method: 'post',
    data,
  })

// 任务详情
export const getTaskInfo = data =>
  request('/portal/verify/webGateway/resultInfo', {
    params: {
      ...data,
    },
  })

export const getChartsData = data =>
  request('/portal/verify/webGateway/resultDetail', {
    params: {
      ...data,
    },
  })

export interface GetRequest {
  id: string
}
export const getRequest = (data: GetRequest) =>
  request('/portal/verify/webGateway/resultResourceDetail', {
    params: {
      ...data,
    },
  })

export const getFailPluginLog = data =>
  request('/portal/verify/webGateway/failedResource', {
    params: {
      ...data,
    },
  })

//攻击组织 /portal/verify/emailGateway/apts
export const getAPTList = () => request('/portal/verify/emailGateway/apts')

//攻击类型 /portal/verify/emailGateway/apts
export const getAttackTypes = (data: { resultId: string }) =>
  request(`/portal/verify/web_gateway/results/${data.resultId}/attack_type`)

// 树结构标签选项
export const getTagTreeSnapshotOptions = data =>
  request(`/portal/verify/webGateway/tag_snapshot_filter`, {
    params: {
      ...data,
    },
  })

// 更新资源拦截状态
export const updateResourceInterceptStatus = data =>
  request(`/portal/verify/webGateway/result/resourceIntercept/${data.id}`, {
    method: 'PUT',
    data: data.list,
  })

// 获取 ATT & CK(攻击路径)
export const getATTCK = (params: { taskId: string; resultId: string }) =>
  request('/portal/verify/web_gateway/detail_att_ck_list', {
    method: 'GET',
    params,
  })

// 获取发件地址
export const getEmailList = () => request('/portal/common/email_users')

export interface GetCaseDetail {
  resourceId: string
  taskId?: string
}

export const getCaseDetail = (data: GetCaseDetail) =>
  request(`/portal/verify/web_gateway/resource_detail/${data.resourceId}`, {
    method: 'get',
    params: data,
  })

// 获取agent列表
export const getAgentList = () => request('/portal/v1/task/agent_list')

// 获取攻击类型列表
export const getAttackTypeList = (params: any) =>
  request('/portal/common/attack/attack_type_filter_list', { params })

export interface SaveCaseToTemplate {
  /**
   * 描述
   */
  description?: string
  /**
   * 模板名字
   */
  name?: string
  /**
   * 关联用例ids
   */
  resourceIds?: string[]
  /**
   * 关联场景ids
   */
  sceneIds?: number[]
  /**
   * 验证模式ids
   */
  verificationModeIds?: number[]
  [property: string]: any
}

// 保存已选择用例为模板
export const saveCaseToTemplate = (data: SaveCaseToTemplate) =>
  request(`/portal/common/resourceTemplate`, {
    method: 'post',
    data,
  })

// 获取模板列表
export interface GetTemplateList {
  /**
   * 模板名字
   */
  'filterParams.name'?: string
  /**
   * 来源类型
   *
   * - OriginTypeSystem: 系统内置
   * - OriginTypeCustom: 手动添加
   */
  'filterParams.originType'?: FilterParamsOriginType
  /**
   * 关联场景ids
   */
  'filterParams.sceneIds'?: number[]
  /**
   * 排序字段
   *
   * - TemplateSortFieldUpdateTime: 更新时间
   * - TemplateSortFieldResourceAmount: 用例数量
   */
  'filterParams.sortField'?: FilterParamsSortField
  /**
   * 排序方式
   *
   * - SortOrderUnspecified: 默认值，未指定排序方式
   * - SortOrderAscending: 正序
   * - SortOrderDescending: 倒序
   */
  'filterParams.sortOrder'?: FilterParamsSortOrder
  /**
   * 验证模式ids
   */
  'filterParams.verificationModeIds'?: number[]
  /**
   * 页码
   */
  page?: number
  /**
   * 页大小
   */
  pageSize?: number
  [property: string]: any
}
/**
 * 来源类型
 *
 * - OriginTypeSystem: 系统内置
 * - OriginTypeCustom: 手动添加
 */
export enum FilterParamsOriginType {
  OriginTypeCustom = 'OriginTypeCustom',
  OriginTypeSystem = 'OriginTypeSystem',
  OriginTypeUnknown = 'OriginTypeUnknown',
}

/**
 * 排序字段
 *
 * - TemplateSortFieldUpdateTime: 更新时间
 * - TemplateSortFieldResourceAmount: 用例数量
 */
export enum FilterParamsSortField {
  TemplateSortFieldResourceAmount = 'TemplateSortFieldResourceAmount',
  TemplateSortFieldUnknown = 'TemplateSortFieldUnknown',
  TemplateSortFieldUpdateTime = 'TemplateSortFieldUpdateTime',
}

/**
 * 排序方式
 *
 * - SortOrderUnspecified: 默认值，未指定排序方式
 * - SortOrderAscending: 正序
 * - SortOrderDescending: 倒序
 */
export enum FilterParamsSortOrder {
  SortOrderAscending = 'SortOrderAscending',
  SortOrderDescending = 'SortOrderDescending',
  SortOrderUnspecified = 'SortOrderUnspecified',
}

export const getTemplateList = (data: GetTemplateList) =>
  request('/portal/common/resourceTemplates', {
    method: 'post',
    data,
  })

export interface GetCaseList {
  /**
   * 攻击类型id
   */
  'filterParams.attackTypeId'?: string
  /**
   * 用例名称
   */
  'filterParams.name'?: string
  /**
   * 来源类型
   *
   * - OriginTypeSystem: 系统内置
   * - OriginTypeCustom: 手动添加
   */
  'filterParams.originType'?: FilterParamsOriginType
  /**
   * 用例分级
   *
   * - ResourceLevelJunior: 初级
   * - ResourceLevelMiddle: 中级
   * - ResourceLevelSenior: 高级
   */
  'filterParams.resourceLevel'?: FilterParamsResourceLevel
  /**
   * 危险等级
   *
   * - RiskLevelLow: 低危
   * - RiskLevelMiddle: 中危
   * - RiskLevelHigh: 高危
   * - RiskLevelGross: 严重
   */
  'filterParams.riskLevel'?: FilterParamsRiskLevel
  /**
   * 排序字段
   */
  'filterParams.sortField'?: FilterParamsSortField
  /**
   * 排序方式
   *
   * - SortOrderUnspecified: 默认值，未指定排序方式
   * - SortOrderAscending: 正序
   * - SortOrderDescending: 倒序
   */
  'filterParams.sortOrder'?: FilterParamsSortOrder
  /**
   * 标签ids
   */
  'filterParams.tagId'?: string[]
  'filterParams.templateId'?: string[]
  /**
   * 验证模式id
   */
  'filterParams.verificationModeId'?: number
  /**
   * 页码
   */
  page?: number
  /**
   * 页大小
   */
  pageSize?: number
  templateId?: string[]
  [property: string]: any
}

/**
 * 来源类型
 *
 * - OriginTypeSystem: 系统内置
 * - OriginTypeCustom: 手动添加
 */

/**
 * 用例分级
 *
 * - ResourceLevelJunior: 初级
 * - ResourceLevelMiddle: 中级
 * - ResourceLevelSenior: 高级
 */
export enum FilterParamsResourceLevel {
  ResourceLevelJunior = 'ResourceLevelJunior',
  ResourceLevelMiddle = 'ResourceLevelMiddle',
  ResourceLevelSenior = 'ResourceLevelSenior',
  ResourceLevelUnknown = 'ResourceLevelUnknown',
}

/**
 * 危险等级
 *
 * - RiskLevelLow: 低危
 * - RiskLevelMiddle: 中危
 * - RiskLevelHigh: 高危
 * - RiskLevelGross: 严重
 */
export enum FilterParamsRiskLevel {
  RiskLevelGross = 'RiskLevelGross',
  RiskLevelHigh = 'RiskLevelHigh',
  RiskLevelLow = 'RiskLevelLow',
  RiskLevelMiddle = 'RiskLevelMiddle',
  RiskLevelUnknown = 'RiskLevelUnknown',
}

// 获取关联用例列表
export const getCaseList = (data: GetCaseList) =>
  request(`/portal/common/resourceTemplate/resources`, {
    method: 'post',
    data,
  })

export interface SaveCaseToTemplate {
  /**
   * 描述
   */
  description?: string
  /**
   * 模板名字
   */
  name?: string
  /**
   * 关联用例ids
   */
  resourceIds?: string[]
  /**
   * 关联场景ids
   */
  sceneIds?: string[]
  /**
   * 验证模式ids
   */
  verificationModeIds?: string[]
}

// 定义接口类型
export enum V1ResourceCenterOriginType {
  OriginTypeCustom = 'OriginTypeCustom',
  OriginTypeSystem = 'OriginTypeSystem',
  OriginTypeUnknown = 'OriginTypeUnknown',
}

export interface V1GetResourceTemplateListReplyTemplateItem {
  description?: string
  name?: string
  originType?: V1ResourceCenterOriginType
  resourceAmount?: number
  resourceIds?: string[]
  sceneIds?: number[]
  updateTime?: Date
  verificationModeIds?: number[]
  [property: string]: any
}

export interface TemplateResponse {
  list?: V1GetResourceTemplateListReplyTemplateItem[]
  total?: number
  [property: string]: any
}

export interface GetCaseDetail {
  resourceId: string
}

// 获取所有模板id
export const getAllTemplateId = (data: GetTemplateList) =>
  request('/portal/common/resourceTemplates/ids', {
    method: 'post',
    data,
  })

// 获取所有用例id
export const getAllCaseId = (data: GetCaseList) =>
  request('/portal/common/resourceTemplate/filterResourceIds', {
    method: 'post',
    data,
    timeout: 8 * 1000,
  })

// 获取用例标签
export const getResourceTagList = data =>
  request('/portal/common/resources/tag/list', {
    method: 'post',
    data,
  })

// 根据templateIds获取resourceIds
export const getResourceIdsByTemplateIds = data =>
  request('/portal/common/resourceTemplate/filter/ResourceIds', {
    method: 'post',
    data,
  })

// 获取安全设备列表
export const getSecurityDeviceList = data =>
  request(`/portal/v1/es/host/${data.agentId}/device`, { params: data })

// 获取任务详情
export const getTaskDetail = data =>
  request(`/portal/verify/wg/task/base/${data.id}`, {
    method: 'post',
    data,
  })
